<template>
    <div class="side-footer">
  <div class="footer-bg"></div>
  <div class="footer-container">
    <div class="footer-content">
      <div class="footer-section">
        <h3>Activities</h3>
        <p>Casual Visit</p>
        <p>Birthday Party</p>
      </div>

      <div class="footer-section">
        <h3>Find Us</h3>
        <p>KiddozCafe</p>
        <p>Shop 1007A, Macquarie Centre, Cnr Waterloo Rd, North Ryde NSW 2113</p>
        <p><a href="tel:0490749866">0490 749 866</a></p>
        <p><a href="mailto:inquiry@kiddozcafe.com.au">inquiry@kiddozcafe.com.au</a></p>
      </div>

      <div class="footer-section">
        <h3>Opening Hours</h3>
        <p>Mon – Sun</p>
        <p>9:30 am to 5:00 pm</p>
        <p class="note">*Opening hours may vary depending on private functions, please check Google Maps for updates</p>
      </div>
    </div>

    <div class="footer-bottom">
      <p>©2025 KiddozCafe. All rights reserved | Build by Xintong Li</p>
    </div>
  </div>
  </div>
</template>

<script>
export default {
  name: 'FooterBar'
}
</script>

<style scoped>
.side-footer{
    margin-top: -45px;
    z-index: 999;
    position: relative;
}
.footer-bg {
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 20px; /* 调整高度以适应波浪图片 */
  background: url('@/assets/footer-bg.png') repeat-x top;
  background-size: cover !important;
}
.footer-container {
  position: relative;
  background: #FEF9E7;
  padding-top: 40px;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  padding: 0 2rem;
  position: relative;
  z-index: 1;
}

.footer-section {
  flex: 1;
  margin: 0 2rem;
}

.footer-section h3 {
  color: #2c3e50;
  margin-bottom: 1rem;
  font-size: 1.2rem;
}

.footer-section p {
  color: #666;
  margin: 0.5rem 0;
  font-size: 0.9rem;
}

.footer-section a {
  color: #666;
  text-decoration: none;
  transition: color 0.3s;
}

.footer-section a:hover {
  color: #2c3e50;
}

.note {
  font-size: 0.8rem;
  font-style: italic;
}

.footer-bottom {
  text-align: center;
  padding: 2rem 0 1rem;
  margin-top: 2rem;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  color: #666;
  font-size: 0.9rem;
}

@media (max-width: 768px) {
  .footer-bg {
    height: 80px; /* 移动端调整波浪高度 */
  }
  .footer-container {
    padding-top: 50px; /* 移动端减小padding */
  }
  
  .footer-content {
    flex-direction: column;
    text-align: center;
  }

  .footer-section {
    margin: 1rem 0;
  }
}
</style> 